import React, {useEffect, useState} from 'react';
import { View, TouchableOpacity, Image, Text, useWindowDimensions, StyleSheet, Alert} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {callApi, getUserId} from '../Helper/Helper';
import notificationImg from '../../image/notification.png';
import offerservicesImg from '../../image/offerservices.png';
import foodhelpImg from '../../image/foodhelp.png';
import householdhelpImg from '../../image/householdhelp.png';
import transporthelpImg from '../../image/transporthelp.png';
import myservicesImg from '../../image/myservices.png';

const NotificationIcon = ({ userId, iconSize, styles, navigation }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [data, setData] = useState(null);
  const KIND = {
    EAT: 'Eat',
    LIVE: 'Live',
    MOVE: 'Move',
  };

  function normalizeItems(data) {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === 'object') {
      const arrayKey = Object.keys(data).find((k) => Array.isArray(data[k]));
      if (arrayKey) return data[arrayKey];
    }
    return [];
  }


  const checkNotifications = async () => {
    if (!userId) return;
    try {
      // Simplified: Call the aggregate offer endpoints for this user
      const categories = ['provider-my-eat-services', 'provider-my-live-services', 'provider-my-move-services'];
      const interestedFetches = categories.map(endpoint =>
        callApi('GET', `${endpoint}/${encodeURIComponent(userId)}`)
          .then(r => {
            const items = normalizeItems(r);
            return items.reduce((acc, item) => {
              const val = Array.isArray(item.interested_by)
                ? item.interested_by.length
                : parseInt(item.interested_by || 0, 10);
              return acc + val;
            }, 0);
          })
          .catch(() => 0)
      );

      const counts = await Promise.all(interestedFetches);
      const totalCounts = counts.reduce((acc, curr) => acc + curr, 0);

      // Compare with last seen count in storage
      const lastSeenStr = await AsyncStorage.getItem(`last_seen_interested_${userId}`);
      const lastSeen = parseInt(lastSeenStr || '0', 10);

      if (totalCounts > lastSeen) {
        setUnreadCount(totalCounts - lastSeen);
      } else {
        setUnreadCount(0);
      }
    } catch (e) {
      console.warn('Notification check failed', e);
    }
  };

  useEffect(() => {
    checkNotifications();
    const interval = setInterval(checkNotifications, 60000);
    return () => clearInterval(interval);
  }, );

  const handlePress = async () => {
    try {
      // 1. Fetch current total count to mark them all as "seen"
      const categories = ['provider-my-eat-services', 'provider-my-live-services', 'provider-my-move-services'];
      const fetches = categories.map(endpoint =>
        callApi('GET', `${endpoint}/${encodeURIComponent(userId)}`)
          .then(r => {
            const items = normalizeItems(r);
            return items.reduce((acc, item) => {
              const val = Array.isArray(item.interested_by)
                ? item.interested_by.length
                : parseInt(item.interested_by || 0, 10);
              return acc + val;
            }, 0);
          })
          .catch(() => 0)
      );

      const counts = await Promise.all(fetches);
      const totalCounts = counts.reduce((acc, curr) => acc + curr, 0);

      await AsyncStorage.setItem(`last_seen_interested_${userId}`, String(totalCounts) );
      setUnreadCount(0);
    } catch (e) {
      console.warn('Failed to reset notification count', e);
    }
    navigation.navigate('ProviderGetMyServices');
  };

  return (
    <TouchableOpacity
      style={[styles.footerItem, { flex: 1, alignItems: 'center' }]}
      onPress={handlePress}>
      <View>
        <Image
          source={notificationImg}
          style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
        />
        {unreadCount > 0 && (

          <View style={localStyles.badge}>
            <Text style={localStyles.badgeText}>{unreadCount > 9 ? '9+' : unreadCount}</Text>
          </View>
        )}
      </View>
      <Text style={styles.footerText}>All My Services</Text>
    </TouchableOpacity>
  );
};

const ProviderSection = ({ navigation, styles }) => {
  const { width } = useWindowDimensions();
  const [userId, setUserId] = useState('');

  // Scale icon size with screen width, with sensible min/max bounds
  const iconSize = Math.max(32, Math.min(64, Math.round(width * 0.12)));

  // Full-width row with evenly distributed items
  const rowPadding = Math.max(8, Math.min(20, Math.round(width * 0.03)));
  const footerRowStyle = [
    styles.footerScrollContent,
    {
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: rowPadding,
    },
  ];

  const footerItemFullWidthStyle = [
    styles.footerItem,
    { flex: 1, alignItems: 'center' },
  ];
  useEffect(() => {
    (async () => {
      if (!userId) {
        try {
          const uid = await getUserId();
          setUserId(uid || '');
        } catch {
          // ignore, handled on demand
        }
      }
    })();
  }, [userId]);
  return (
    <View style={styles.footerContainer}>
      <View style={footerRowStyle}>
        <TouchableOpacity
          style={footerItemFullWidthStyle}
          onPress={() => navigation.navigate('ProviderPostServices')}>
          <Image
            source={offerservicesImg}
            style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
          />
          <Text style={styles.footerText}>Sell</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={footerItemFullWidthStyle}
          onPress={() => navigation.navigate('ProviderGetEatFromConsumer')}>
          <Image
            source={foodhelpImg}
            style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
          />
          <Text style={styles.footerText}>Food</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={footerItemFullWidthStyle}
          onPress={() => navigation.navigate('ProviderGetLiveFromConsumer')}>
          <Image
            source={householdhelpImg}
            style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
          />
          <Text style={styles.footerText}>Household</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={footerItemFullWidthStyle}
          onPress={() => navigation.navigate('ProviderGetMoveFromConsumer')}>
          <Image
            source={transporthelpImg}
            style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
          />
          <Text style={styles.footerText}>Transport</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={footerItemFullWidthStyle}
          onPress={() => navigation.navigate('ProviderDetails', { pUserId: userId })}>
          <Image
            source={myservicesImg}
            style={[styles.footerIcon, { width: iconSize, height: iconSize }]}
          />
          <Text style={styles.footerText}>Profile</Text>
        </TouchableOpacity>

        <NotificationIcon
          userId={userId}
          iconSize={iconSize}
          styles={styles}
          navigation={navigation}
        />


      </View>
    </View>
  );
};

const localStyles = StyleSheet.create({
  badge: {
    position: 'absolute',
    right: -6,
    top: -3,
    backgroundColor: '#FF3B30',
    borderRadius: 10,
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1.5,
    borderColor: '#fff',
  },
  badgeText: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
  },
});

export default ProviderSection;
